import { Box, Button, CircularProgress, Modal } from "@mui/material";
import Background from "../../layout/Background";
// import Mapa from "./mapa/Mapa";
import Mapa from "./Mapa"
import { Typography } from "@mui/material";
import Formulario from "./Formulario";
import { useAppContext } from "../../contexts/AppContext";
import Alerta from "../../components/alerta/Alerta";
import { useEffect, useState } from "react";
import MapComponent from "./mapa/MapComponent";

export default function Recorrido() {
    const { logged, loading, login } = useAppContext();

    const [open, setOpen] = useState(false);

    const ubicacion = {
        lat: -32.41469454047811,
        lng: -63.2423299238929,
        zoom: 13
    };

    useEffect(() => {
        document.title = "Recorrido Peñero";
    }, []);

    const downloadPliego = () => {
        // el pliego esta en ./pleigo
        window.open("/pliego.pdf");
    }

    return (
        <Box sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            px: "10px",
            alignItems: 'center',
            boxSizing: 'border-box',
            gap: '20px',
            minHeight: "calc(100vh - 80px)",
        }}
        >
            <Box sx={{
                width: '100%',
                height: "600px",
                maxHeight: "75vh",
                mt: '10px',
                overflow: 'hidden',
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '8px',

            }}>
                <Mapa />
            </Box>
            <Box sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '20px',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
                {/* <Button variant="contained" sx={{
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    color: '#FFFFFF',
                    borderRadius: '8px',
                    px: '20px',
                    py: '10px',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    my: '20px',
                    backdropFilter: 'blur(10px)',
                    "&:hover": {
                        backgroundColor: '#D4A646',
                    }

                }}
                    onClick={() => setOpen(true)}
                >
                    Tutoriales
                </Button> */}
                <Button variant="contained" sx={{
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    color: '#FFFFFF',
                    borderRadius: '8px',
                    px: '20px',
                    py: '10px',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    my: '20px',
                    backdropFilter: 'blur(10px)',
                    "&:hover": {
                        backgroundColor: '#D4A646',
                    }

                }}
                    onClick={() => downloadPliego()}
                >
                    Ver convocatoria
                </Button>
                {/* {!logged &&
                    <Button variant="contained" sx={{
                        backgroundColor: 'rgba(255,255,255,0.1)',
                        color: '#FFFFFF',
                        borderRadius: '8px',
                        px: '20px',
                        py: '10px',
                        fontSize: '20px',
                        fontWeight: 'bold',
                        my: '20px',
                        backdropFilter: 'blur(10px)',
                        "&:hover": {
                            backgroundColor: '#D4A646',
                        }

                    }}
                        onClick={login}
                    >
                        Iniciar Sesión
                    </Button>
                } */}
            </Box>
            {/* <Typography variant="h6" sx={{ textAlign: 'center' }}>
                La convocatoria ya ha cerrado.
            </Typography> */}

            {/* {logged ? loading ?
                <CircularProgress />
                :
                <Formulario />
                :
                <></>
            } */}
            {/* <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                disableAutoFocus
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    maxWidth: '90%',
                    boxSizing: 'border-box',
                    backgroundColor: 'rgba(255,255,255,0.6)',
                    backdropFilter: 'blur(10px)',
                    borderRadius: 1,
                    boxShadow: 24,
                    p: 4,

                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        mt: '20px',
                    }}>
                        <Box sx={{
                            borderRadius: '8px',
                            boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.5)',
                            px: '10px',
                            py: '20px',
                            my: '10px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            backgroundColor: 'rgba(255,255,255,0.8)',
                        }}>

                            <Typography variant="body1" gutterBottom sx={{ color: "black" }}>
                                Tutorial para completar el formulario
                            </Typography>
                            <Button variant="contained" sx={{

                            }}
                                onClick={() => window.open("/tutorial.mp4")}
                            >
                                Ver Tutorial
                            </Button>
                        </Box>
                        <Box sx={{
                            borderRadius: '8px',
                            boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.5)',
                            px: '10px',
                            py: '20px',
                            my: '10px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            backgroundColor: 'rgba(255,255,255,0.8)',
                        }}>
                            <Typography variant="body1" gutterBottom sx={{ color: "black", textAlign: "center" }}>
                                Tutorial para agregar un representado con CIDI
                            </Typography>

                            <Button variant="contained" sx={{


                            }}
                                onClick={() => window.open("https://secretariadeambiente.cba.gov.ar/wp-content/uploads/2018/05/Administrador-de-relaciones.pdf")}
                            >
                                Ver Tutorial
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal > */}
        </Box >
    );
}